// import { useState } from 'react';
// import { purchaseReturnApi, poApi } from '../api';
// import { useData, submitForm, useSubmit } from '../hooks/useData';
// import { Spinner, Modal, PageHeader, Field, Empty, EditBtn, Badge, Icons } from '../components/common';
// import toast from 'react-hot-toast';
// import { downloadReport } from '../utils/downloadUtils';

// export default function PurchaseReturnPage() {
//   const { data, loading, reload } = useData(purchaseReturnApi.list);
//   const { data: completedPos }    = useData(poApi.completed);

//   const [modal, setModal]   = useState(null); // 'return' | 'edit'
//   const [selPo, setSelPo]   = useState(null); // full PO with details
//   const [retLines, setRetLines] = useState([]); // [{item_id, item_name, orig_qty, return_qty, unit_price}]
//   const [returnNote, setReturnNote] = useState('');
//   const [editRow, setEditRow] = useState(null);
//   const [loadingPo, setLoadingPo] = useState(false);
//   const [exporting, setExporting] = useState(false);
//   const [doSubmit, saving] = useSubmit();

//   // Open return form — load PO with its item details
//   const openReturn = async (po) => {
//     setLoadingPo(true);
//     try {
//       const res = await poApi.getOne(po.id);
//       const full = res.data.data;
//       setSelPo(full);
//       // Build return lines from PO details — default return qty = 0
//       setRetLines((full.details || []).map(d => ({
//         item_id:    d.item_id,
//         item_name:  d.item_name,
//         orig_qty:   parseInt(d.quantity) || 0,
//         unit_price: parseFloat(d.unit_price) || 0,
//         return_qty: 0,
//       })));
//       setReturnNote('');
//       setModal('return');
//     } catch { toast.error('Failed to load PO details'); }
//     finally { setLoadingPo(false); }
//   };

//   // Open edit — show existing return record
//   const openEdit = async (row) => {
//     setLoadingPo(true);
//     try {
//       const res = await poApi.getOne(row.po_id);
//       const full = res.data.data;
//       setSelPo(full);
//       setEditRow(row);
//       // Parse stored return lines (stored as JSON in return_note or separate)
//       let lines = [];
//       try { lines = JSON.parse(row.return_lines || '[]'); } catch {}
//       // Merge with PO details
//       setRetLines((full.details || []).map(d => {
//         const existing = lines.find(l => String(l.item_id) === String(d.item_id));
//         return {
//           item_id:    d.item_id,
//           item_name:  d.item_name,
//           orig_qty:   parseInt(d.quantity) || 0,
//           unit_price: parseFloat(d.unit_price) || 0,
//           return_qty: existing ? parseInt(existing.return_qty) : 0,
//         };
//       }));
//       setReturnNote(row.return_note || '');
//       setModal('edit');
//     } catch { toast.error('Failed to load return details'); }
//     finally { setLoadingPo(false); }
//   };

//   const close = () => { setModal(null); setSelPo(null); setEditRow(null); setRetLines([]); setReturnNote(''); };

//   const setQty = (idx, val) => {
//     const parsed = parseInt(val) || 0;
//     const max    = retLines[idx].orig_qty;
//     if (parsed > max) { toast.error(`Cannot exceed original qty (${max}) for ${retLines[idx].item_name}`); return; }
//     setRetLines(ls => ls.map((l, i) => i === idx ? { ...l, return_qty: parsed } : l));
//   };

//   const totalReturnQty   = retLines.reduce((s, l) => s + (l.return_qty || 0), 0);
//   const totalReturnValue = retLines.reduce((s, l) => s + (l.return_qty || 0) * (l.unit_price || 0), 0);

//   const handleSave = async () => {
//     if (!returnNote.trim()) { toast.error('Return note is required'); return; }
//     if (totalReturnQty === 0) { toast.error('Please enter return quantity for at least one item'); return; }

//     const linesWithQty = retLines.filter(l => l.return_qty > 0);
//     const payload = {
//       po_id:        selPo.id,
//       return_note:  returnNote,
//       quantity:     totalReturnQty,
//       total_price:  totalReturnValue.toFixed(2),
//       return_lines: JSON.stringify(linesWithQty.map(l => ({ item_id: l.item_id, return_qty: l.return_qty }))),
//     };

//     if (modal === 'return') {
//       submitForm(() => purchaseReturnApi.create(payload), 'Purchase return recorded', reload, close);
//     } else {
//       submitForm(() => purchaseReturnApi.update(editRow.id, payload), 'Return updated', reload, close);
//     }
//   };

//   const handleExport = async () => {
//     setExporting(true);
//     try {
//       await downloadReport(purchaseReturnApi.exportExcel, 'purchase-return-history.xlsx');
//     } catch {
//       toast.error('Export failed — please try again');
//     } finally {
//       setExporting(false);
//     }
//   };

//   return (
//     <div>
//       <PageHeader title="Purchase Returns" subtitle="Return goods to supplier" />

//       {/* Completed PO list */}
//       <div className="card" style={{ marginBottom: 20 }}>
//         <div className="card-header"><span className="card-title">Completed POs — Ready for Return</span></div>
//         {completedPos.length === 0
//           ? <div className="card-body"><Empty msg="No completed POs available for return" /></div>
//           : <div className="table-wrap">
//               <table className="responsive-table">
//                 <thead><tr><th>PO #</th><th>Brand / Supplier</th><th>Qty</th><th>Total</th><th>Action</th></tr></thead>
//                 <tbody>{completedPos.map(po => (
//                   <tr key={po.id}>
//                     <td data-label="PO #">
//                       <div className="td-primary font-mono">{po.po_number}</div>
//                       <div className="td-muted">{po.po_date}</div>
//                     </td>
//                     <td data-label="Brand / Supplier">
//                       <div>{po.brand_name}</div>
//                       <div className="td-muted">{po.supplier_name}</div>
//                     </td>
//                     <td data-label="Qty" className="font-mono">{po.total_qty}</td>
//                     <td data-label="Total" className="font-mono">৳{Number(po.total_price).toLocaleString()}</td>
//                     <td data-label="Action">
//                       <button className="btn btn-danger btn-sm" onClick={() => openReturn(po)}
//                         disabled={loadingPo}>
//                         Return
//                       </button>
//                     </td>
//                   </tr>
//                 ))}</tbody>
//               </table>
//             </div>}
//       </div>

//       {/* Return history */}
//       <div className="card">
//         <div className="card-header">
//           <span className="card-title">Return History</span>
//           <button className="btn btn-secondary btn-sm" onClick={handleExport} disabled={exporting}>
//             {exporting ? 'Exporting…' : 'Export Excel'}
//           </button>
//         </div>
//         {loading ? <Spinner /> : (
//           <div className="table-wrap">
//             {data.length === 0 ? <Empty /> : (
//               <table className="responsive-table">
//                 <thead><tr><th>PO #</th><th>Brand / Supplier</th><th>Qty</th><th>Value</th><th>Date</th><th>Status</th><th>Actions</th></tr></thead>
//                 <tbody>{data.map(r => (
//                   <tr key={r.id}>
//                     <td data-label="PO #" className="td-primary font-mono">{r.po_number}</td>
//                     <td data-label="Brand / Supplier">
//                       <div>{r.brand_name}</div>
//                       <div className="td-muted">{r.supplier_name}</div>
//                     </td>
//                     <td data-label="Qty" className="font-mono">{r.quantity}</td>
//                     <td data-label="Value" className="font-mono">৳{Number(r.total_price).toLocaleString()}</td>
//                     <td data-label="Date" className="text-muted">{r.return_date}</td>
//                     <td data-label="Status"><Badge status={r.status} /></td>
//                     <td data-label="Actions"><div className="action-cell"><EditBtn onClick={() => openEdit(r)} /></div></td>
//                   </tr>
//                 ))}</tbody>
//               </table>
//             )}
//           </div>
//         )}
//       </div>

//       {/* Return / Edit Modal */}
//       {modal && selPo && (
//         <Modal
//           title={modal === 'return' ? `Purchase Return` : `Edit Return`}
//           onClose={close} size="modal-lg"
//           footer={<>
//             <button className="btn btn-secondary" onClick={close}>Cancel</button>
//             <button className="btn btn-danger" onClick={handleSave}>
//               {modal === 'return' ? 'Submit Return' : 'Save Changes'}
//             </button>
//           </>}>

//           {/* PO Summary */}
//           <div style={{ marginBottom: 18, padding: '14px 16px', background: 'var(--c-accent-tint)', border: '1px solid var(--c-border)', borderLeft: '3px solid var(--c-accent)', borderRadius: 'var(--r-sm)' }}>
//             <div style={{ fontWeight: 600, fontSize: '1rem', color: 'var(--c-text)', marginBottom: 10 }}>
//               {selPo.po_number}
//             </div>
//             <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(150px,1fr))', gap: '4px 24px', fontSize: '.88rem', color: 'var(--c-text-2)' }}>
//               <span><strong>Supplier:</strong> {selPo.supplier_name}</span>
//               <span><strong>Brand:</strong> {selPo.brand_name}</span>
//               <span><strong>PO Date:</strong> {selPo.po_date}</span>
//               <span><strong>Original Total:</strong> ৳{Number(selPo.total_price).toLocaleString()}</span>
//             </div>
//           </div>

//           {/* Per-item return quantities */}
//           <div className="section-label">Return Quantity per Item</div>
//           <div style={{ overflowX: 'auto', marginBottom: 16 }}>
//             <table className="detail-table">
//               <thead><tr>
//                 <th style={{ minWidth: 200 }}>Item Name</th>
//                 <th style={{ minWidth: 110, textAlign: 'right' }}>Original Qty</th>
//                 <th style={{ minWidth: 110, textAlign: 'right' }}>Unit Price (৳)</th>
//                 <th style={{ minWidth: 120 }}>Return Qty</th>
//                 <th style={{ minWidth: 110, textAlign: 'right' }}>Return Value (৳)</th>
//               </tr></thead>
//               <tbody>
//                 {retLines.map((line, idx) => (
//                   <tr key={line.item_id}>
//                     <td className="td-primary">{line.item_name}</td>
//                     <td style={{ textAlign: 'right' }} className="font-mono">{line.orig_qty}</td>
//                     <td style={{ textAlign: 'right' }} className="font-mono">৳{Number(line.unit_price).toLocaleString()}</td>
//                     <td>
//                       <input
//                         type="number"
//                         value={line.return_qty}
//                         min="0"
//                         max={line.orig_qty}
//                         onChange={e => setQty(idx, e.target.value)}
//                         style={{ width: 90 }}
//                       />
//                       <span style={{ fontSize: '.75rem', color: 'var(--c-text-3)', marginLeft: 6 }}>
//                         / {line.orig_qty}
//                       </span>
//                     </td>
//                     <td style={{ textAlign: 'right', fontWeight: 500 }} className="font-mono">
//                       ৳{((line.return_qty || 0) * line.unit_price).toLocaleString()}
//                     </td>
//                   </tr>
//                 ))}
//                 {retLines.length === 0 && (
//                   <tr><td colSpan={5} style={{ textAlign: 'center', padding: 20, color: 'var(--c-text-3)' }}>
//                     No item details found for this PO. Add items to the PO first.
//                   </td></tr>
//                 )}
//               </tbody>
//             </table>
//           </div>

//           {/* Totals */}
//           {totalReturnQty > 0 && (
//             <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 24, marginBottom: 16, padding: '10px 14px', background: 'var(--c-bg)', borderRadius: 'var(--r-sm)', border: '1px solid var(--c-border)', fontSize: '.9rem' }}>
//               <span>Total Return Qty: <strong className="font-mono">{totalReturnQty}</strong></span>
//               <span>Total Return Value: <strong className="font-mono text-danger">৳{totalReturnValue.toLocaleString()}</strong></span>
//             </div>
//           )}

//           <Field label="Return Note" required>
//             <textarea
//               value={returnNote}
//               onChange={e => setReturnNote(e.target.value)}
//               rows={3}
//               placeholder="Reason for return — required…"
//             />
//           </Field>
//         </Modal>
//       )}
//     </div>
//   );
// }
import { useState } from 'react';
import { purchaseReturnApi, poApi } from '../api';
import { useData, submitForm, useSubmit } from '../hooks/useData';
import { Spinner, Modal, PageHeader, Field, Empty, EditBtn, Badge, Icons } from '../components/common';
import toast from 'react-hot-toast';
import { downloadReport } from '../utils/downloadUtils';

export default function PurchaseReturnPage() {
  const { data, loading, reload } = useData(purchaseReturnApi.list);
  const { data: completedPos }    = useData(poApi.completed);

  const [modal, setModal]   = useState(null); // 'return' | 'edit'
  const [selPo, setSelPo]   = useState(null); // full PO with details
  const [retLines, setRetLines] = useState([]); // [{item_id, item_name, orig_qty, return_qty, unit_price}]
  const [returnNote, setReturnNote] = useState('');
  const [editRow, setEditRow] = useState(null);
  const [loadingPo, setLoadingPo] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [doSubmit, saving] = useSubmit();

  // Open return form — load PO with its item details
  const openReturn = async (po) => {
    setLoadingPo(true);
    try {
      const res = await poApi.getOne(po.id);
      const full = res.data.data;
      setSelPo(full);
      // Build return lines from PO details — default return qty = 0
      setRetLines((full.details || []).map(d => ({
        item_id:    d.item_id,
        item_name:  d.item_name,
        orig_qty:   parseInt(d.quantity) || 0,
        unit_price: parseFloat(d.unit_price) || 0,
        return_qty: 0,
      })));
      setReturnNote('');
      setModal('return');
    } catch { toast.error('Failed to load PO details'); }
    finally { setLoadingPo(false); }
  };

  // Open edit — show existing return record
  const openEdit = async (row) => {
    setLoadingPo(true);
    try {
      const res = await poApi.getOne(row.po_id);
      const full = res.data.data;
      setSelPo(full);
      setEditRow(row);
      // Parse stored return lines (stored as JSON in return_note or separate)
      let lines = [];
      try { lines = JSON.parse(row.return_lines || '[]'); } catch {}
      // Merge with PO details
      setRetLines((full.details || []).map(d => {
        const existing = lines.find(l => String(l.item_id) === String(d.item_id));
        return {
          item_id:    d.item_id,
          item_name:  d.item_name,
          orig_qty:   parseInt(d.quantity) || 0,
          unit_price: parseFloat(d.unit_price) || 0,
          return_qty: existing ? parseInt(existing.return_qty) : 0,
        };
      }));
      setReturnNote(row.return_note || '');
      setModal('edit');
    } catch { toast.error('Failed to load return details'); }
    finally { setLoadingPo(false); }
  };

  const close = () => { setModal(null); setSelPo(null); setEditRow(null); setRetLines([]); setReturnNote(''); };

  const setQty = (idx, val) => {
    const parsed = parseInt(val) || 0;
    const max    = retLines[idx].orig_qty;
    if (parsed > max) { toast.error(`Cannot exceed original qty (${max}) for ${retLines[idx].item_name}`); return; }
    setRetLines(ls => ls.map((l, i) => i === idx ? { ...l, return_qty: parsed } : l));
  };

  // Freight rate per unit, from this PO's overall delivery+other cost spread
  // across its total quantity — same rate the PO's Unit Cost Calculator used
  // to build each line's landed unit price in the first place.
  const freightPerUnit = selPo && parseInt(selPo.total_qty) > 0
    ? ((parseFloat(selPo.delivery_charge) || 0) + (parseFloat(selPo.other_cost) || 0)) / parseInt(selPo.total_qty)
    : 0;

  const totalReturnQty = retLines.reduce((s, l) => s + (l.return_qty || 0), 0);
  // Refundable = item-cost-only portion (what the supplier actually credits back)
  const totalRefundable = retLines.reduce((s, l) => {
    const itemCostPerUnit = Math.max(0, (l.unit_price || 0) - freightPerUnit);
    return s + itemCostPerUnit * (l.return_qty || 0);
  }, 0);
  // Freight Loss = non-refundable delivery/other-cost portion, written off
  // (couriers don't refund shipping already paid, even if goods are returned)
  const totalFreightLoss = retLines.reduce((s, l) => {
    const itemCostPerUnit  = Math.max(0, (l.unit_price || 0) - freightPerUnit);
    const freightPortion   = Math.max(0, (l.unit_price || 0) - itemCostPerUnit);
    return s + freightPortion * (l.return_qty || 0);
  }, 0);

  const handleSave = async () => {
    if (!returnNote.trim()) { toast.error('Return note is required'); return; }
    if (totalReturnQty === 0) { toast.error('Please enter return quantity for at least one item'); return; }

    const linesWithQty = retLines.filter(l => l.return_qty > 0);
    const payload = {
      po_id:        selPo.id,
      return_note:  returnNote,
      return_lines: JSON.stringify(linesWithQty.map(l => ({ item_id: l.item_id, return_qty: l.return_qty }))),
      // quantity / total_price / freight_loss_value are recomputed
      // authoritatively on the server from the PO + return_lines
    };

    if (modal === 'return') {
      submitForm(() => purchaseReturnApi.create(payload), 'Purchase return recorded', reload, close);
    } else {
      submitForm(() => purchaseReturnApi.update(editRow.id, payload), 'Return updated', reload, close);
    }
  };

  const handleExport = async () => {
    setExporting(true);
    try {
      await downloadReport(purchaseReturnApi.exportExcel, 'purchase-return-history.xlsx');
    } catch {
      toast.error('Export failed — please try again');
    } finally {
      setExporting(false);
    }
  };

  return (
    <div>
      <PageHeader title="Purchase Returns" subtitle="Return goods to supplier" />

      {/* Completed PO list */}
      <div className="card" style={{ marginBottom: 20 }}>
        <div className="card-header"><span className="card-title">Completed POs — Ready for Return</span></div>
        {completedPos.length === 0
          ? <div className="card-body"><Empty msg="No completed POs available for return" /></div>
          : <div className="table-wrap">
              <table className="responsive-table">
                <thead><tr><th>PO #</th><th>Brand / Supplier</th><th>Qty</th><th>Total</th><th>Action</th></tr></thead>
                <tbody>{completedPos.map(po => (
                  <tr key={po.id}>
                    <td data-label="PO #">
                      <div className="td-primary font-mono">{po.po_number}</div>
                      <div className="td-muted">{po.po_date}</div>
                    </td>
                    <td data-label="Brand / Supplier">
                      <div>{po.brand_name}</div>
                      <div className="td-muted">{po.supplier_name}</div>
                    </td>
                    <td data-label="Qty" className="font-mono">{po.total_qty}</td>
                    <td data-label="Total" className="font-mono">৳{Number(po.total_price).toLocaleString()}</td>
                    <td data-label="Action">
                      <button className="btn btn-danger btn-sm" onClick={() => openReturn(po)}
                        disabled={loadingPo}>
                        Return
                      </button>
                    </td>
                  </tr>
                ))}</tbody>
              </table>
            </div>}
      </div>

      {/* Return history */}
      <div className="card">
        <div className="card-header">
          <span className="card-title">Return History</span>
          <button className="btn btn-secondary btn-sm" onClick={handleExport} disabled={exporting}>
            {exporting ? 'Exporting…' : 'Export Excel'}
          </button>
        </div>
        {loading ? <Spinner /> : (
          <div className="table-wrap">
            {data.length === 0 ? <Empty /> : (
              <table className="responsive-table">
                <thead><tr><th>PO #</th><th>Brand / Supplier</th><th>Qty</th><th>Refundable</th><th>Freight Loss</th><th>Date</th><th>Status</th><th>Actions</th></tr></thead>
                <tbody>{data.map(r => (
                  <tr key={r.id}>
                    <td data-label="PO #" className="td-primary font-mono">{r.po_number}</td>
                    <td data-label="Brand / Supplier">
                      <div>{r.brand_name}</div>
                      <div className="td-muted">{r.supplier_name}</div>
                    </td>
                    <td data-label="Qty" className="font-mono">{r.quantity}</td>
                    <td data-label="Refundable" className="font-mono text-success">৳{Number(r.total_price).toLocaleString()}</td>
                    <td data-label="Freight Loss" className="font-mono text-danger">
                      {Number(r.freight_loss_value) > 0 ? `৳${Number(r.freight_loss_value).toLocaleString()}` : '—'}
                    </td>
                    <td data-label="Date" className="text-muted">{r.return_date}</td>
                    <td data-label="Status"><Badge status={r.status} /></td>
                    <td data-label="Actions"><div className="action-cell"><EditBtn onClick={() => openEdit(r)} /></div></td>
                  </tr>
                ))}</tbody>
              </table>
            )}
          </div>
        )}
      </div>

      {/* Return / Edit Modal */}
      {modal && selPo && (
        <Modal
          title={modal === 'return' ? `Purchase Return` : `Edit Return`}
          onClose={close} size="modal-lg"
          footer={<>
            <button className="btn btn-secondary" onClick={close}>Cancel</button>
            <button className="btn btn-danger" onClick={handleSave}>
              {modal === 'return' ? 'Submit Return' : 'Save Changes'}
            </button>
          </>}>

          {/* PO Summary */}
          <div style={{ marginBottom: 18, padding: '14px 16px', background: 'var(--c-accent-tint)', border: '1px solid var(--c-border)', borderLeft: '3px solid var(--c-accent)', borderRadius: 'var(--r-sm)' }}>
            <div style={{ fontWeight: 600, fontSize: '1rem', color: 'var(--c-text)', marginBottom: 10 }}>
              {selPo.po_number}
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(150px,1fr))', gap: '4px 24px', fontSize: '.88rem', color: 'var(--c-text-2)' }}>
              <span><strong>Supplier:</strong> {selPo.supplier_name}</span>
              <span><strong>Brand:</strong> {selPo.brand_name}</span>
              <span><strong>PO Date:</strong> {selPo.po_date}</span>
              <span><strong>Original Total:</strong> ৳{Number(selPo.total_price).toLocaleString()}</span>
            </div>
          </div>

          {/* Per-item return quantities */}
          <div className="section-label">Return Quantity per Item</div>
          <div style={{ overflowX: 'auto', marginBottom: 16 }}>
            <table className="detail-table">
              <thead><tr>
                <th style={{ minWidth: 200 }}>Item Name</th>
                <th style={{ minWidth: 110, textAlign: 'right' }}>Original Qty</th>
                <th style={{ minWidth: 110, textAlign: 'right' }}>Unit Price (৳)</th>
                <th style={{ minWidth: 120 }}>Return Qty</th>
                <th style={{ minWidth: 110, textAlign: 'right' }}>Return Value (৳)</th>
              </tr></thead>
              <tbody>
                {retLines.map((line, idx) => (
                  <tr key={line.item_id}>
                    <td className="td-primary">{line.item_name}</td>
                    <td style={{ textAlign: 'right' }} className="font-mono">{line.orig_qty}</td>
                    <td style={{ textAlign: 'right' }} className="font-mono">৳{Number(line.unit_price).toLocaleString()}</td>
                    <td>
                      <input
                        type="number"
                        value={line.return_qty}
                        min="0"
                        max={line.orig_qty}
                        onChange={e => setQty(idx, e.target.value)}
                        style={{ width: 90 }}
                      />
                      <span style={{ fontSize: '.75rem', color: 'var(--c-text-3)', marginLeft: 6 }}>
                        / {line.orig_qty}
                      </span>
                    </td>
                    <td style={{ textAlign: 'right', fontWeight: 500 }} className="font-mono">
                      ৳{((line.return_qty || 0) * line.unit_price).toLocaleString()}
                    </td>
                  </tr>
                ))}
                {retLines.length === 0 && (
                  <tr><td colSpan={5} style={{ textAlign: 'center', padding: 20, color: 'var(--c-text-3)' }}>
                    No item details found for this PO. Add items to the PO first.
                  </td></tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Totals */}
          {totalReturnQty > 0 && (
            <div style={{ marginBottom: 16, padding: '12px 16px', background: 'var(--c-bg)', borderRadius: 'var(--r-sm)', border: '1px solid var(--c-border)', fontSize: '.9rem' }}>
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 24, flexWrap: 'wrap' }}>
                <span>Total Return Qty: <strong className="font-mono">{totalReturnQty}</strong></span>
                <span>Refundable (Item Cost): <strong className="font-mono text-success">৳{totalRefundable.toLocaleString()}</strong></span>
                {totalFreightLoss > 0 && (
                  <span>Freight Loss (non-refundable): <strong className="font-mono text-danger">৳{totalFreightLoss.toLocaleString()}</strong></span>
                )}
              </div>
              {totalFreightLoss > 0 && (
                <div style={{ fontSize: '.76rem', color: 'var(--c-text-3)', textAlign: 'right', marginTop: 6 }}>
                  Delivery &amp; other cost already paid to the courier isn't refunded by the supplier on return — it's written off as a loss.
                </div>
              )}
            </div>
          )}

          <Field label="Return Note" required>
            <textarea
              value={returnNote}
              onChange={e => setReturnNote(e.target.value)}
              rows={3}
              placeholder="Reason for return — required…"
            />
          </Field>
        </Modal>
      )}
    </div>
  );
}